<template>
	<v-card 
		flat
		color="secondary"
		class="map-container"
		dark
	>
	
		<v-card-title primary class="title">
			Map  
		</v-card-title>
	
		<!-- Tabs for Filters -->
		
			
		<v-tabs
			v-model="tab"
			color="secondary"	
						
		>
		 
			<v-tabs-slider color="white" />
			<v-tab 
				v-for="filter in filters"
				:key="filter"
			>
				{{ filter }}
			</v-tab>
		
		
		 
		</v-tabs>
		<!-- End Tabs -->

		<v-container grid-list-xl>
			<div ref="map" class="map" />
		</v-container>
	</v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import { debounce } from 'lodash'
import MarkerClusterer from '@google/markerclusterer'
import loadGoogleMapsApi from 'load-google-maps-api'

const MAP_CENTER =  { lat: 35.9426466, lng: 14.2382669 }

export default {
	props: {
		estates: {
			type: Array,
			required: true
		}
	},

	data () {
		return {
			tab: null,
			map: null,
			markersCluster: null,
			googleMaps: null,
			filters: ['Properties', 'Actions', 'Activity', 'Bussines', 'Crowfonding', 'Creativity']
		}
	},

	computed: {
		mapReference: function () {
			return this.$refs.map
		}
	},

	watch: {
		estates: 'refreshEstates'
	},

	mounted: function () {
		this.initMap ()
	},

	methods: {
		...mapMutations (['selectEstate', 'showVisibileEstates']),
		
		initMap () {
			loadGoogleMapsApi ({
				key: 'AIzaSyDXCoe4UkXl-yNH5KHOiPbeFHppirDrJas',
			})
				.then (googleMaps => {
					this.googleMaps = googleMaps
					this.map = new googleMaps.Map (this.mapReference, {
						zoom: 10,
						center: MAP_CENTER,
						mapTypeId: 'terrain',
						disableDefaultUI: true,
						zoomControl: true,
						fullscreenControl: true
					})
					this.map.addListener ('click', this.onMapClick)
					
					// Retrieve the visible markers/clusters on the map
					this.map.addListener ('bounds_changed', debounce (this.updateVisibleMarkers, 500))

					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition (position => {
							var pos = {
								lat: position.coords.latitude,
								lng: position.coords.longitude
							}
							//this.map.panTo (pos)
							new googleMaps.Marker ({
								position: pos,
								map: this.map,
								title: 'Your current position',
								id: 'position'
							})
						}, err => {
							console.log (err)
						})
					}
				})
		},

		refreshEstates (estates) {
			if (!estates)
				return
			
			// Map not created yet -- delay the marker rendering
			if (!this.map) {
				setTimeout (() => this.refreshEstates (estates), 2000)
				return
			}

			if (this.markersCluster)
				this.markersCluster.clearMarkers ()

			if (!this.markersCluster)
				this.markersCluster = new MarkerClusterer (this.map, null, {
					imagePath: 'https://googlemaps.github.io/js-marker-clusterer/images/m'
				})
			
			const markers = estates.map ((estate, index) => {
				const marker = new this.googleMaps.Marker ({
					position: estate.position,
					title: estate.name,
					animation: this.googleMaps.Animation.DROP,
					map: this.map,
					estate,
					id: index
				})
				marker.addListener ('click', () => this.onMarkerClick (marker))
				return marker
			})

			this.markersCluster.addMarkers (markers)

			// Update the visible markers manually
			this.updateVisibleMarkers ()
		},

		onMarkerClick (marker) {
			if (this.selectedMarker && marker && marker.id !== this.selectedMarker.id) {
				this.selectedMarker.setAnimation (null)
			}

			if (marker.getAnimation () !== null) {
				marker.setAnimation (null)
				this.selectedMarker = null
				this.selectEstate (null)

			} else {
				marker.setAnimation (this.googleMaps.Animation.BOUNCE)
				this.map.panTo (marker.getPosition ())
				this.selectedMarker = marker
				
				// Save selected event
				this.selectEstate (marker.estate)
			}
		},

		onMapClick () {
			// Unselect marker if it's selected
			if (this.selectedMarker) {
				this.onMarkerClick (this.selectedMarker)
			}
		},

		updateVisibleMarkers () {
			if (!this.map)
				return
	
			const bounds = this.map.getBounds ()

			if (!bounds)
				return

			this.showVisibileEstates (this.estates.reduce ((visibleEstates, estate) => {
				if (bounds.contains (estate.position))
					visibleEstates.push (estate)
				return visibleEstates
			}, []))
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.map-container {
	border: 1px solid white !important;
	min-height: 650px;
	max-height: 650px;
}

.map {
	width: 100%;
	height: 500px;
}
</style>

